import React, { useMemo, useEffect } from 'react';
import { Grid } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import dayjs from 'dayjs';
import { model as TaskModel } from '../../AppGrid/TaskTable';
import strings from '../../Globalization/index';
import { useBreadcrumbs } from '../../contexts/Breadcrumbs';
import consts from '../../consts';

const TaskTable = TaskModel.createGridBase();
const DashboardTaskList = () => {
	const [searchParams] = useSearchParams();
	const [, setBreadcrumbs] = useBreadcrumbs({
		breadcrumbs: [{ text: strings.Tasks }],
		docTitle: strings.Tasks,
		subbreadcrumbs: [{ text: strings.Dashboard, to: '/dashboard' }, { text: strings.Tasks }]
	});

	const disableLoadPref = Boolean(searchParams.get('disableLoadPref') || 'false');
	const hideTypeFilter = searchParams.get('hideTypeFilter');
	const equipmentTypeId = searchParams.get('equipmentTypeId');
	const taskStatusId = searchParams.get('taskStatusId');

	const parentFilters = useMemo(() => {
		const date = dayjs().hour(0).minute(0).second(0);
		const ExpectedRunAt = date.format(consts.MomentFormat.MonthDateYear);
		const utcDate = date.utc().millisecond(0).toISOString();
		let filters = [
			{ "operator": "$eq", "value": taskStatusId, "property": "TaskStatusId", "type": "numeric" },
			{ "operator": "$gt", "value": ExpectedRunAt, "property": "ExpectedRunAt", "type": "date", "convert": "true", "utcDate": utcDate },
		];

		return { filter: filters };
	}, [taskStatusId]);

	return (
		<Grid container>
			<Grid size={12}>
				<TaskTable parentFilters={parentFilters} />
			</Grid>
		</Grid>
	);
};

export default DashboardTaskList